import {
  iwocapayTelDisplay,
  iwocapayTelLink,
} from '../../../../src/constants.json';
import TelephoneIcon from '../../../components/svg/TelephoneIcon.svg?react';

export const HelpBox = () => {
  return (
    <div className="mb-l mt-xl">
      <h4 className="m-0 text-m font-med">Need some help?</h4>
      <div className="grid grid-cols-[max-content_1fr] items-center gap-s">
        <p className="m-0 text-s">Give us a call on</p>
        <a href={iwocapayTelLink} className="text-primary-10 no-underline">
          <div className="flex items-center gap-xs">
            <TelephoneIcon className="h-[15px] w-[15px]" />
            <p className="m-0 p-0 text-s font-bold">{iwocapayTelDisplay}</p>
          </div>
        </a>
      </div>

      <div className="text-xs font-reg text-structure-40">
        Mon - Fri (9am - 6pm)
      </div>
      <a
        href="https://www.iwoca.co.uk/iwocapay-buyer-pay-later"
        target="_blank"
        rel="noopener noreferrer"
        className="text-xs text-primary-40"
      >
        Find out more about iwocaPay
      </a>
    </div>
  );
};
